import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PosSalesService } from 'src/app/services/possalesservice';
import { LoaderComponent } from '../loader/loader.component';
import { ANGULAR_MODULES } from '../shared-imports';
import { LayoutService } from 'src/app/services/layout.service';
import { WordReplacePipe } from '../word-replace.pipe';

@Component({
  selector: 'app-pos-vendor-search',
  templateUrl: './pos-vendor-search.component.html',
  standalone: true,
  imports: [ANGULAR_MODULES, LoaderComponent,WordReplacePipe],
  styleUrls: ['./pos-vendor-search.component.scss']
})
export class POSVendorSearchComponent implements OnInit, OnDestroy {
  public loaderIcon: Promise<boolean>;
  public data: any[] = [];
  private subscriptions: Subscription[] = [];

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @Output() vendorData = new EventEmitter<any>();

  pageNumber = 0;
  pageSize = 20;
  allRecords: any[] = [];   // keep full list
  partId;
  parts = [];
  searchField = 'CustName';
  searchValue;
  filters = {
    vendorId: '',
    vendorName: '',
    partName: ''
  };

  constructor(private posSalesService: PosSalesService, private toastr: ToastrService,
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
    this.getParts();
    this.loadAllVendors();
  }

  getParts() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.layoutService.getParts().subscribe((res: any) => {
      if (res) {
        this.parts = res;
        this.loaderIcon = Promise.resolve(false);
        this.partId = '';
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  loadAllVendors(): void {
    this.loaderIcon = Promise.resolve(true);
    const vendorFilter = {
      PageNumber: this.pageNumber,
      PageSize: this.pageSize,
      SearchField: this.searchField,
      SearchValue: this.searchValue,
      PartName: this.partId
    }
    this.subscriptions.push(
      this.posSalesService.getPOSVendorList(vendorFilter)
        .subscribe((res: any) => {
          if (res && res.length > 0) {
            res = res.filter((el) => !el.VendorInactive);
            const mapped = res.map((el) => {
              return {
                VendorId: el.VendorId,
                MarketVendorId: el.MarketVendorId,
                VendorName: el.VendorNameFormat != null
                  ? (el.VendorNameFormat
                    .replace('<First Name>', el.VendorFirstName || '')
                    .replace('<Last Name>', el.VendorLastName || '')
                    .replace('<Middle Name>', el.VendorMiddleName || '')
                  ).trim().replace(/^, /, '').replace(/^,|,$/g, '')
                  : el.VendorName,
                BoothNumber: el.BoothNumber,
                PartName: el.PartName
              };
            });

            this.data = [...this.data, ...mapped];

            this.pageNumber++;
          }
          this.loaderIcon = Promise.resolve(false);
        }, error => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error('Error loading vendors');
        })
    );
  }

  onScroll(): void {
    const el = this.scrollContainer.nativeElement;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
      this.loadAllVendors(); // directly call API for next page
    }
  }

  resetAndLoad(): void {
    this.pageNumber = 0;
    this.data = [];
    this.loadAllVendors();
  }

  VendorDetails(item: any, event: MouseEvent): void {
    event.stopPropagation();
    const boothlist = this.data.filter(e => e.VendorId == item.VendorId);
    const boothNumbers = boothlist.map(e => e.BoothNumber).join(', ');

    this.vendorData.emit({
      vendorId: item.VendorId,
      marketVendorId: item.MarketVendorId,
      vendorName: item.VendorName,
      boothNumber: item.BoothNumber,
      boothList: boothNumbers
    });
    this.partId = "";
  }

  resetSearchFields() {
    this.searchValue = '';
    this.searchField = 'CustName';
    this.partId = '';
    this.resetAndLoad();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s?.unsubscribe());
  }
}
